/**
 * Textos de Qualitat i APPCC (`ca`): ajunta els fitxers de cada tall. Cablejat a `ca.ts` amb un sol
 * `...qualityCa`; així cada tall edita només el seu fitxer.
 */

import { suppliersCa } from './suppliers.ca.js';
import { trainingCa } from './training.ca.js';
import { nonConformitiesCa } from './nonconformities.ca.js';
import { selfChecksCa } from './selfchecks.ca.js';
import { receptionCa } from './reception.ca.js';
import { evidenceCa } from './evidence.ca.js';
import { plantaCa } from './planta.ca.js';

export const qualityCa = {
  ...suppliersCa,
  ...trainingCa,
  ...nonConformitiesCa,
  ...selfChecksCa,
  ...receptionCa,
  ...evidenceCa,
  ...plantaCa,
} as const;
